<zui-status-icon-base
  class="__icon-base"
  [size]="size"
  [status]="status"
  [statusText]="statusText"
  [tooltip]="tooltip"
  [pulsing]="pulsingStatusesMap[status]">
</zui-status-icon-base>

<ng-content></ng-content>
<zui-uploading-icon
  *ngIf="uploading"
  class="__uploading">
</zui-uploading-icon>

<span class="__icon-amount" *ngIf="amount !== undefined">{{ amount }}</span>
